import { FC, memo } from 'react'

import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect, Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import * as SC from './styles'

export const Filter: FC = memo(() => {
  const { data, search, onFilterChange } = useAlertsContext()
  const { relationshipOptions, annualReviewStatuses, form } = data

  const formApi = useForm({
    defaultValues: {
      annualReviewsStatus: form.annualReviewsStatus,
      annualReviewsCompanyID: form.annualReviewsCompanyID
    }
  })

  const clearForm = () => {
    formApi.reset()
    onFilterChange(
      {
        annualReviewsStatus: undefined,
        annualReviewsCompanyID: undefined,
        annualReviewsPage: 1
      },
      'annualReviews'
    )
  }

  const updateSearchParams = (newValue: Partial<AlertsPayload>) => {
    onFilterChange({ ...search, ...newValue, annualReviewsPage: 1 }, 'annualReviews')
  }

  const hasActiveFilters = Boolean(search.annualReviewsStatus || search.annualReviewsCompanyID)

  return (
    <FilterPanel isDirty={hasActiveFilters} onReset={clearForm} expanded={false}>
      <SC.FormWrapper>
        <SC.FilterWrapper>
          <SC.ItemWrapper>
            <formApi.Field
              name="annualReviewsCompanyID"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ annualReviewsCompanyID: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Relationships"
                  input={(inputProps) => (
                    <CompanySelect hideMyCompaniesFilter preloadedOptions={relationshipOptions} {...inputProps} />
                  )}
                />
              )}
            />
          </SC.ItemWrapper>
          <SC.ItemWrapper>
            <formApi.Field
              name="annualReviewsStatus"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ annualReviewsStatus: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Status"
                  input={(inputProps) => <Select data={annualReviewStatuses} {...inputProps} />}
                />
              )}
            />
          </SC.ItemWrapper>
        </SC.FilterWrapper>
      </SC.FormWrapper>
    </FilterPanel>
  )
})
